import React from 'react';

import useAnalytics from 'hooks/useAnalytics';
import useLocalStorage from 'hooks/useLocalStorage';

import { IS_PRODUCTION } from 'constants/Global';
import { PATH, PATH_NAME } from 'constants/Routes';
import { COOKIES_STORAGE_KEY } from 'modules/app/constants';

import PageLoader from 'common/pages/Loader';
import TestPage from 'components/test/TestPage';
import CustomerUnsubscribePage from 'components/customers/Leads/UnsubscribePage';

const InterventionPage = React.lazy(() => import('./components/interventions/InterventionPage'));

const ROUTES = {
  [PATH_NAME.AUDIT]: React.lazy(() => import('./components/audit/AuditPage')),
  [PATH_NAME.CUSTOMIZE]: React.lazy(() => import('./components/customize/CustomizePage')),
  [PATH_NAME.APPOINTMENT]: React.lazy(() => import('./components/appointments/AppointmentPage')),
  [PATH_NAME.DEALERS_KEY_DEPOSIT]: React.lazy(() => import('./components/appointments/AppointmentPage')),
  [PATH_NAME.CAMPAIGN]: InterventionPage,
  [PATH_NAME.CAMPAIGN_FILE]: InterventionPage,
  [PATH_NAME.INTERVENTION]: InterventionPage,
  [PATH_NAME.INTERVENTION_ENTITIES]: InterventionPage,
  [PATH_NAME.CUSTOMER_LEAD_UNSUBSCRIBE]: CustomerUnsubscribePage,
  [PATH_NAME.FOLLOW_UP]: React.lazy(() => import('./components/followUps')),
  [PATH_NAME.UNSUBSCRIBE]: React.lazy(() => import('./components/common/UnsubscribePage')),
  ...(!IS_PRODUCTION ? { [PATH_NAME.TEST]: TestPage } : {}),
  [PATH_NAME.PAGE_404]: React.lazy(() => import('./components/common/pages/Page404')),
};

const Router = () => {
  const { location } = window;

  /** @type {{value: import('modules/app/types').CookiesData}} */
  const { value: cookiePreferences } = useLocalStorage({ key: COOKIES_STORAGE_KEY });
  const { ga } = useAnalytics();

  React.useEffect(() => {
    ga.send({ hitType: 'pageview', page: location });
  }, [cookiePreferences?.ANALYTICS, ga, location]);

  const Component = React.useMemo(() => Object.entries(ROUTES).find(
    ([pathName]) => PATH[pathName]?.match(location.pathname)
  )?.[1] ?? ROUTES[PATH_NAME.PAGE_404], [location]);

  return (
    <React.Suspense fallback={<PageLoader />}>
      <Component />
    </React.Suspense>
  );
};

export default Router;
